import { Section } from 'components/Section';
import { CardLarge } from 'components/Card';
import { isMobile as isMobileSelector } from 'components/Shared/responsive';
import { useSelector } from 'react-redux';
import { Grid, Cell } from 'components/Grid';
import { Appearances } from 'models/SectionBlock';
import { PopularKnowledgebase } from 'models/PopularKnowledgebase';
import { rm } from 'utils';

export const Articles = ({ title, articles }: PopularKnowledgebase) => {
  const isMobile = useSelector(isMobileSelector);

  return (
    <Section title={title} isDesktop={!isMobile} appearance={Appearances.Tertiary}>
      <Grid large="4" tablet="2" phone="1" gutters="medium">
        {articles.map((item, index) => (
          <Cell key={index}>
            <CardLarge
              button={{ title: rm('startpage_popular_knowledgebase_button') }}
              information={{ title: item.title, text: item.body }}
              appearance="card"
              categoryUrl={item.url}
              image={item.image}
            />
          </Cell>
        ))}
      </Grid>
    </Section>
  );
};
